<template>
  <button
    class="v-button"
    @click="clickEventHandler()"
  >
    <slot/>
  </button>
</template>

<script>
export default {
  name: 'VButton',
  methods: {
    clickEventHandler(){
      this.$emit('click');
    }
  }
}
</script>

<style scoped>
.v-button {
  border: none;
  background: rgb(58, 156, 242);
  height: 40px;
  padding: 0 40px;
  color: #ffffff;
  border-radius: 50px;
  outline: none;
  cursor: pointer;
}

.v-button:hover {
  background: rgb(55, 134, 204);
}

.v-button:active {
  background: rgb(42, 99, 150);
}
</style>

